import { render, staticRenderFns } from "./PagesTitle.vue?vue&type=template&id=5116d7aa&"
import script from "./PagesTitle.vue?vue&type=script&lang=js&"
export * from "./PagesTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports